import { render } from "./CostKolMember.vue?vue&type=template&id=4f2fea54"
import script from "./CostKolMember.vue?vue&type=script&lang=js"
export * from "./CostKolMember.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__